import React from 'react';
import AutosizeInput from 'components/input-autosize/input-autosize';
import { KEYS } from 'common/constants';
import { css } from 'linaria';
import { validateEmail } from 'common/utilities';
const inputWrapper = "i1h0u21y"; // NOTE: AutosizeInput requires pure strings as className

const autoWrapper = "a157jxs6";
const inputStyle = "i18xvto0";
export function TagInput(props) {
  const {
    onBlur,
    setValue,
    value,
    handleRemoveAction,
    hasActiveTags,
    setBlur,
    deactivateTags,
    email,
    addTag,
    submitForm,
    characterLimit,
    hasError,
    setError,
    clearError,
    inputRef
  } = props;
  /* Input Events
  –––––––––––––––––––––––––––––––––––––––––––––––––––– */

  const onChange = event => setValue(event.target.value);

  const onKeyUp = event => {
    switch (event.keyCode) {
      // Handle intent to remove
      case KEYS.BACKSPACE:
      case KEYS.DELETE:
        {
          clearInputError();
          if (!value.length) handleRemoveAction();
          return;
        }
      // Handle intent to exit

      case KEYS.ESCAPE:
        {
          clearInputError();
          setValue('');
          if (hasActiveTags) deactivateTags();
          if (!value.length) setBlur();
          return;
        }
      // How necessary is this on every keyup

      default:
        if (hasActiveTags) deactivateTags();
    }
  };

  const onKeyInput = event => {
    // Check email validation
    if (event.charCode === KEYS.COMMA || event.keyCode === KEYS.TAB || event.keyCode === KEYS.ENTER) {
      if (email && !validateEmail(value)) {
        setInputError();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    } // Add Tag on comma or tab


    if (event.charCode === KEYS.COMMA || event.keyCode === KEYS.TAB) {
      event.preventDefault();
      event.stopPropagation();
      addTag(`${value}`);
      return;
    } // Close on double enter


    if (event.keyCode === KEYS.ENTER) {
      event.preventDefault();
      event.stopPropagation();
      if (value.trim()) return addTag(`${value}`);
      submitForm();
    } // Set error on tag length limit


    if (value && value.length > characterLimit && event.keyCode !== KEYS.BACKSPACE && event.keyCode !== KEYS.DELETE && event.keyCode !== KEYS.LEFT && event.keyCode !== KEYS.UP && event.keyCode !== KEYS.RIGHT && event.keyCode !== KEYS.DOWN && event.keyCode !== KEYS.ENTER) {
      setInputError();
      event.preventDefault();
      return;
    }
  };

  const setInputError = () => !hasError ? setError() : null;

  const clearInputError = () => hasError ? clearError() : null;

  return <div className={inputWrapper}>
      <AutosizeInput data-cy="tagging-input" autoFocus={true} //eslint-disable-line
    className={autoWrapper} inputRef={inputRef} inputClassName={inputStyle} value={value} onChange={onChange} onBlur={onBlur} onKeyUp={onKeyUp} onKeyDown={onKeyInput} onKeyPress={onKeyInput} />
    </div>;
}

require("./tag.input.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag.input.js");